import { DeviceFingerprintService, getOrCreateSessionId } from 'utils/device-fingerprint';
import type { PaymentContext } from './types';
// Risk - Payment Context
export const buildPaymentContext = async (): Promise<PaymentContext> => {
  const context: PaymentContext = {};

  try {
    const fingerprintResult = await DeviceFingerprintService.collect().catch(() => null);

    const sessionId = getOrCreateSessionId();
    if (sessionId) {
      context.sessionId = sessionId;
    }

    const canvasHash = fingerprintResult?.signals?.canvasHash;
    if (canvasHash) {
      context.canvasHash = canvasHash;
    }
  } catch {
    // All fields are optional — return partial or empty context
  }

  return context;
};
